import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.OAuthRestService
 * @augments rest.services.BaseRestService
 *
 * @description
 * This class contains methods used to manage authentication
 * using http requests.
 */
export default class OAuthRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
    * @ngdoc function
    * @name rest.services.OAuthRestService#post
    * @methodOf rest.services.OAuthRestService
    * @function
    *
    * @description
    * This method will make a http request (POST) with user's credentials
    * in order to obtain the token.
    *
    * @param {object} oauthPayload OAuth payload
    *
    * @returns {Promise} The promise of the call.
    */
    post(oauthPayload, extraHeaders) {

        return super.post(oauthPayload, 'oauth/', extraHeaders);

    }

}

_serviceDependencies.push(OAuthRestService);

angular.module('rest.services')
    .service('OAuthRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/oauth.js